import React from 'react';
import { useAddAiPromptComponent } from './useAddAiPromptComponent';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddAiPrompt.styles';
import theme from '../../../../styles/theme';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import { IAiPrompt } from '../../../../types/interfaces/ai-prompt';

interface IAddAiPromptProps {
  aiPrompt: IAiPrompt | null;
  onClose: () => void;
}

export default function AddAiPrompt(props: IAddAiPromptProps) {
  const { aiPrompt, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading } = useAddAiPromptComponent(onClose, aiPrompt);
  const { classes } = useStyles(theme);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.key')}
              fullWidth
              name="key"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.value')}
              fullWidth
              name="value"
              formik={formik}
              multiline
              rows={15}
            />
          </Grid>
        </Grid>
        <Box className={classes.addAiPromptButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {aiPrompt ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
